import React from 'react';
import { Grid } from 'antd';
import { Card, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

/**
 * ChartContainer - A wrapper component for charts with loading state (Responsive)
 * @param {Object} props
 * @param {React.ReactNode} props.children - Chart component to wrap
 * @param {string} props.title - Chart title
 * @param {boolean} props.loading - Whether the chart is loading
 * @param {React.ReactNode} props.extra - Extra content to display in card header
 */
function ChartContainer({ children, title, loading = false, extra = null }) {
  const screens = useBreakpoint();
  const isXs = !screens.xs;
  const isSm = screens.sm;

  return (
    <Card
      title={title}
      extra={extra}
      className="shadow-sm"
      style={{ height: '100%' }}
      headStyle={{
        padding: isXs ? '12px 16px' : '16px 24px',
        fontSize: isXs ? 14 : 16
      }}
      bodyStyle={{
        padding: isXs ? 12 : 16
      }}
    >
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        tip="Cargando..."
      >
        <div style={{ minHeight: loading ? 200 : 'auto' }}>
          {children}
        </div>
      </Spin>
    </Card>
  );
}

export default ChartContainer;
